import { useEffect, useState } from 'react'

import { api } from '../api/client'
import { useAsync } from '../hooks/useAsync'
import { t } from '../i18n/lingua'
import { Card, ErrorBanner } from './common'

/** «30 min», «4 h», «24 h». */
function etichetta(minuti: number): string {
  if (minuti < 60) return t('{n} minuti', { n: minuti })
  const ore = minuti / 60
  return ore === 1 ? t('1 ora') : t('{n} ore', { n: ore })
}

/**
 * La durata della sessione del tenant, in Impostazioni (solo amministratori).
 *
 * È **per inattività**: finché qualcuno usa la console la sessione si rinnova da
 * sola; scade dopo questi minuti senza attività. Vale per il tenant, non per il
 * singolo utente: quanto può restare aperta una console incustodita è una
 * politica di sicurezza del cliente. Vedi control-plane/app/services/session_service.py.
 */
export function SessioneCard() {
  const dati = useAsync(() => api.sessionSettings(), [])
  const [scelta, setScelta] = useState<number | null>(null)
  const [errore, setErrore] = useState<unknown>(null)
  const [salvato, setSalvato] = useState(false)
  const [lavoro, setLavoro] = useState(false)
  useEffect(() => {
    if (dati.data) setScelta(dati.data.idle_minutes)
  }, [dati.data])

  async function salva() {
    if (scelta == null) return
    setErrore(null)
    setSalvato(false)
    setLavoro(true)
    try {
      await api.setSessionSettings(scelta)
      setSalvato(true)
      await dati.reload()
    } catch (err) {
      setErrore(err)
    } finally {
      setLavoro(false)
    }
  }

  return (
    <Card title={t('Sessione')}>
      <p className="field__hint" style={{ marginTop: 0 }}>
        {t('Definisce il periodo massimo di inattività prima della richiesta di una nuova autenticazione. La sessione viene rinnovata automaticamente durante l’utilizzo, è condivisa tra schede e finestre del browser e si applica a tutti gli utenti del tenant dal successivo rinnovo della sessione.')}
      </p>
      <ErrorBanner error={dati.error ?? errore} />
      <div className="field" style={{ maxWidth: 320 }}>
        <label htmlFor="sessione-durata">{t('Scade dopo un’inattività di')}</label>
        <select id="sessione-durata" value={scelta ?? ''} onChange={(e) => { setScelta(Number(e.target.value)); setSalvato(false) }}>
          {(dati.data?.choices ?? []).map((m) => (
            <option key={m} value={m}>{etichetta(m)}</option>
          ))}
        </select>
      </div>
      <div className="rowactions" style={{ textAlign: 'left' }}>
        <button type="button" onClick={() => void salva()} disabled={lavoro || scelta == null || scelta === dati.data?.idle_minutes}>
          {lavoro ? t('Salvataggio…') : t('Salva')}
        </button>
        {salvato && <span className="muted"> {t('Salvato.')}</span>}
      </div>
    </Card>
  )
}
